import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Pill, History, Syringe } from "lucide-react";

export default function PatientTreatment() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/patient/treatment-plan").then((r) => setData(r.data)).catch(() => {}); }, []);
  if (!data) return <p className="text-sm text-muted-foreground">Loading…</p>;

  const { current, history } = data;
  return (
    <div className="space-y-6" data-testid="patient-treatment">
      <h1 className="font-heading text-2xl font-bold tracking-tight">My Treatment Plan</h1>

      {current ? (
        <div className="bg-card border border-border rounded-xl p-6" data-testid="patient-current-plan">
          <div className="flex items-center gap-2 mb-4">
            <Syringe className="w-5 h-5 text-primary" />
            <span className="font-heading text-xl font-bold">{current.medication}</span>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <Info label="Dosage" value={current.dose || "—"} />
            <Info label="Frequency" value={current.frequency || "—"} />
            <Info label="Route" value={current.route || "—"} />
            <Info label="Since" value={current.effective_date?.slice(0, 10)} />
          </div>
          {current.instructions && (
            <p className="text-sm text-muted-foreground mt-4 pt-4 border-t border-border">{current.instructions}</p>
          )}
        </div>
      ) : (
        <div className="bg-card border border-dashed border-border rounded-xl p-8 text-center text-sm text-muted-foreground">No active treatment plan yet.</div>
      )}

      {history?.length > 0 && (
        <div>
          <h3 className="flex items-center gap-2 font-heading text-base font-semibold mb-3"><History className="w-4 h-4" /> Past Plans</h3>
          <div className="space-y-3">
            {history.map((p) => (
              <div key={p.id} className="bg-card border border-border rounded-lg p-4">
                <p className="font-medium">{p.medication}{p.dose ? ` · ${p.dose}` : ""}</p>
                <p className="text-xs text-muted-foreground mt-0.5">From {p.effective_date?.slice(0, 10)}</p>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

function Info({ label, value }) {
  return (
    <div>
      <p className="text-xs uppercase tracking-[0.05em] font-medium text-muted-foreground">{label}</p>
      <p className="font-medium mt-1">{value}</p>
    </div>
  );
}
